/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { NavigationCollectionsRemote } from '@jira/polaris__component-navigation-collections-store/src/TypesRemoteNavigationCollection.tsx';
import {
	fetchAllCollections,
	fetchCollection,
} from '@jira/polaris__component-collections/src/updateCollection.tsx';
import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';

export const createNavigationCollectionsRemote = (
	_: CreateUIAnalyticsEvent,
): NavigationCollectionsRemote => ({
	fetch: () => fetchAllCollections(),
	fetchCollection: (collectionUUID: string) => fetchCollection(collectionUUID),
});
